import React, { useState } from 'react';
import ReservationModal from './ReservationModal';
import './ReservationCTA.css';

const ReservationCTA = () => {
  const [open, setOpen] = useState(false);
  return (
    <section className="reservation-cta" id="book">
      <div className="container">
        <h2>Service brunch bientôt disponible</h2>
        <p>Nous préparons une expérience brunch exceptionnelle qui sera prochainement disponible.</p>
        <button className="cta-btn" onClick={() => setOpen(true)}>Être notifié</button>
      </div>
      <ReservationModal isOpen={open} onClose={() => setOpen(false)} />
    </section>
  );
};

export default ReservationCTA;

